// @flow

import React, { type Node } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

type Props = {
  children: Node,
};

const Content = ({ children }: Props) => (
  <section className={classnames(styles.content)}>{children}</section>
);

export default Content;
